import { render, staticRenderFns } from "./ProcessGeneral.vue?vue&type=template&id=0cf7df39&"
import script from "./ProcessGeneral.vue?vue&type=script&lang=js&"
export * from "./ProcessGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports